import { canv } from '@/canv/global.js'
import {toolBase} from '@/tools/toolBase';

import { Group } from '@/group';

import { sketchWidget } from '@/elements/sketch.js'
import { checkClickOnSketch, checkIntersectionSketchAndMouseLine, handleDeleteGroup } from './utils';

export class penTool extends toolBase {

    constructor() {
        super();
    }

    getToolView() {
        return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.9734 5.97398L15.3872 4.56012C15.5647 4.38263 15.7753 4.24182 16.0072 4.14576C16.239 4.04969 16.4875 4.00024 16.7385 4.00024C16.9895 4.00024 17.238 4.04969 17.4698 4.14576C17.7017 4.24182 17.9124 4.38263 18.0898 4.56012L19.4406 5.91093C19.7988 6.26922 20 6.75511 20 7.26173C20 7.76836 19.7988 8.25425 19.4406 8.61254L18.0267 10.0264M13.9734 5.97398L4.78713 15.1593C4.46995 15.4764 4.27448 15.8951 4.23497 16.3419L4.00378 18.9595C3.99136 19.0986 4.00962 19.2388 4.05726 19.3701C4.10489 19.5015 4.18075 19.6207 4.27949 19.7196C4.37823 19.8184 4.49744 19.8944 4.62873 19.9421C4.76001 19.9899 4.90017 20.0083 5.03933 19.996L7.65688 19.7648C8.10437 19.7257 8.52378 19.5302 8.84146 19.2126L18.0267 10.0264M13.9734 5.97398L18.0267 10.0264" stroke="#2C2D32" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;
    }

    getToolTipName() {
        return "Рисование";
    }

    getToolHotKey() {
        return "P";
    }

    select() {
        super.select();
        this.openSubMenu();
    }

    unselect() {
        super.unselect();
        this.ghostSketch = null;
        this.closeSubMenu();
    }

    openSubMenu() {
        var subMenu = document.createElement('div');
        subMenu.classList.add("penTool_subMenu");
        document.body.prepend(subMenu);

        subMenu.innerHTML = this.getSubMenuTemplate();

        var modes = document.getElementsByClassName('penTool_subMenuTopItem');
        for (var i = 0; i < modes.length; i++) {
            var mode = modes[i].getAttribute("mode");
            if (mode == this.mode) {
                modes[i].classList.add("penTool_subMenuTopItemSelected");
            }
            modes[i].addEventListener('mouseup', this.changeMode.bind(this, mode), false);
        }

        var colors = document.getElementsByClassName('penTool_subMenuColorsItem');
        for (var i = 0; i < colors.length; i++) {
            var color = colors[i].getAttribute("color");
            if (color == this.color) {
                colors[i].classList.add("penTool_subMenuTopItemSelected");
            }
            colors[i].addEventListener('mouseup', this.changeColor.bind(this, color), false);
        }

        var widths = document.getElementsByClassName('penTool_subMenuWidthItem');
        for (var i = 0; i < widths.length; i++) {
            var width = widths[i].getAttribute("lineWidth");
            if (width == this.lineWidth) {
                widths[i].classList.add("penTool_subMenuTopItemSelected");
            }
            widths[i].addEventListener('mouseup', this.changeWidth.bind(this, width), false);
        }


        var menuItem = document.getElementsByClassName(this.getToolClass())[0];
        var menuSize = menuItem.getBoundingClientRect();
        subMenu.style.top = (menuSize.top - (subMenu.getBoundingClientRect().height - menuSize.height) / 2).toString() + "px";

        subMenu.style.transform = "translate(0px)";
        subMenu.style.opacity = "1";
    }

    closeSubMenu() {
        var subMenu = document.getElementsByClassName('penTool_subMenu')[0];
        if (subMenu) {
            subMenu.outerHTML = "";
        }
    }


    reopenOrCloseSubmenu() {
        const subMenu = document.getElementsByClassName('penTool_subMenu')[0];
        if (subMenu) {
            this.closeSubMenu();
        } else {
            this.openSubMenu();
        }
    }


    getSubMenuTemplate() {
        return  `
            <div class="penTool_subMenuTop">
                <div class="penTool_subMenuTopItem" mode="pen">
                    <svg fill="none" viewBox="0 0 24 24" height="20" width="20" focusable="false">
                        <path xmlns="http://www.w3.org/2000/svg" stroke-width="2" stroke="currentColor" d="M13.4097 2.80282L19 18.1762V24C19 24.5523 18.5523 25 18 25H6C5.44771 25 5 24.5523 5 24V18.1762L10.5903 2.80282C11.069 1.48631 12.931 1.4863 13.4097 2.80282Z"></path>
                        <path xmlns="http://www.w3.org/2000/svg" stroke-width="2" stroke="currentColor" d="M8.57141 9H15.4286"></path>
                    </svg>
                </div>
                <div class="penTool_subMenuTopItem" mode="highlighter">
                    <svg fill="none" viewBox="0 0 24 24" height="20" width="20" focusable="false">
                    <path xmlns="http://www.w3.org/2000/svg" stroke-width="2" stroke="currentColor" d="M18 13V14H19H19.1479C19.6705 14 20.1049 14.4023 20.145 14.9233L20.9201 25L3.07988 25L3.85501 14.9233C3.89508 14.4023 4.32953 14 4.85206 14H5H6V13V11.0002C6 10.4467 6.44716 10.0001 6.99837 10.0001H6.9984L17.0017 10.0001H17.0017C17.5529 10.0001 18 10.4467 18 11.0001V13Z"></path>
                    <path xmlns="http://www.w3.org/2000/svg" stroke-width="2" stroke="currentColor" d="M8 9C8 9.55228 8.44772 10 9 10H15C15.5523 10 16 9.55228 16 9V3.43961C16 2.80856 15.4227 2.33527 14.8039 2.45903L8.80389 3.65903C8.33646 3.75251 8 4.16293 8 4.63961V9Z"></path>
                    <path xmlns="http://www.w3.org/2000/svg" fill="currentColor" d="M17 13V15H7V13H17Z"></path>
                    </svg>
                </div>
            </div>
            <div class="penTool_subMenuTopItem" mode="eraser">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.9995 12L9.9995 5.00004M19.9995 20H6.99955M9.9368 19.0628L18.6054 10.3941C19.7935 9.2061 20.3875 8.61207 20.6101 7.92709C20.8058 7.32456 20.8058 6.67551 20.6101 6.07298C20.3875 5.388 19.7935 4.79397 18.6054 3.60592L18.3937 3.39415C17.2056 2.2061 16.6116 1.61207 15.9266 1.38951C15.3241 1.19373 14.675 1.19373 14.0725 1.38951C13.3875 1.61207 12.7935 2.2061 11.6054 3.39415L3.39366 11.6059C2.20561 12.794 1.61158 13.388 1.38902 14.073C1.19324 14.6755 1.19324 15.3246 1.38902 15.9271C1.61158 16.6121 2.20561 17.2061 3.39366 18.3941L4.06229 19.0628C4.40819 19.4087 4.58114 19.5816 4.78298 19.7053C4.96192 19.815 5.15701 19.8958 5.36108 19.9448C5.59126 20 5.83585 20 6.32503 20H7.67406C8.16324 20 8.40784 20 8.63801 19.9448C8.84208 19.8958 9.0372 19.815 9.2161 19.7053C9.418 19.5816 9.5909 19.4087 9.9368 19.0628Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div class="penTool_subMenuDividor"></div>
            <div class="penTool_subMenuColors">
                <div class="penTool_subMenuColorsItem" color="#000000"><div class="penTool_subMenuColorsItemInner" style="background-color: #000000"></div></div>
                <div class="penTool_subMenuColorsItem" color="#f24822"><div class="penTool_subMenuColorsItemInner" style="background-color: #f24822"></div></div>
                <div class="penTool_subMenuColorsItem" color="#ffa629"><div class="penTool_subMenuColorsItemInner" style="background-color: #ffa629"></div></div>
                <div class="penTool_subMenuColorsItem" color="#ffcd29"><div class="penTool_subMenuColorsItemInner" style="background-color: #ffcd29"></div></div>
                <div class="penTool_subMenuColorsItem" color="#14ae5c"><div class="penTool_subMenuColorsItemInner" style="background-color: #14ae5c"></div></div>
                <div class="penTool_subMenuColorsItem" color="#0d99ff"><div class="penTool_subMenuColorsItemInner" style="background-color: #0d99ff"></div></div>
                <div class="penTool_subMenuColorsItem" color="#9747ff"><div class="penTool_subMenuColorsItemInner" style="background-color: #9747ff"></div></div>
                <div class="penTool_subMenuColorsItem" color="#ffffff"><div class="penTool_subMenuColorsItemInner" style="background-color: #ffffff"></div></div>
            </div>
            <div class="penTool_subMenuDividor"></div>
            <div class="penTool_subMenuWidth">
                <div class="penTool_subMenuWidthItem" lineWidth=3><div class="penTool_subMenuWidthItemOne"></div></div>
                <div class="penTool_subMenuWidthItem" lineWidth=6><div class="penTool_subMenuWidthItemTwo"></div></div>
                <div class="penTool_subMenuWidthItem" lineWidth=11><div class="penTool_subMenuWidthItemThree"></div></div>
            </div>
        `;
    }

    changeColor(color) {
        this.color = color;
        var colors = document.getElementsByClassName("penTool_subMenuColorsItem");
        for (var i = 0; i < colors.length; i++) {
            colors[i].classList.remove("penTool_subMenuTopItemSelected");
            var color = colors[i].getAttribute("color");
            if (color == this.color) {
                colors[i].classList.add("penTool_subMenuTopItemSelected");
            }
        }
    }

    changeWidth(width) {
        this.lineWidth = width;
        var widths = document.getElementsByClassName("penTool_subMenuWidthItem");
        for (var i = 0; i < widths.length; i++) {
            widths[i].classList.remove("penTool_subMenuTopItemSelected");
            var width = widths[i].getAttribute("lineWidth");
            if (width == this.lineWidth) {
                widths[i].classList.add("penTool_subMenuTopItemSelected");
            }
        }
    }

    changeMode(newMode) {
        this.mode = newMode;
        this.chooseCursor();

        const modes = document.getElementsByClassName("penTool_subMenuTopItem");

        for (let i = 0; i < modes.length; i++) {
            modes[i].classList.remove("penTool_subMenuTopItemSelected");

            const mode = modes[i].getAttribute("mode");

            if (mode == this.mode) {
                modes[i].classList.add("penTool_subMenuTopItemSelected");
            }
        }
    }

    eraseSketchByCrossing() {
        const allSketches = canv.canvasController.findAllWidgetsByConstructorName('sketch');

        for (const sketch of allSketches) {
            if (checkClickOnSketch(sketch) || checkIntersectionSketchAndMouseLine(sketch)) {
                canv.canvasController.deleteProcessor(sketch.parent);
            }
        }

        canv.redraw();
    }

    eraseSketchByClick() {
        const allSketches = canv.canvasController.findAllWidgetsByConstructorName('sketch');
        const deleteSketches = [];

        for (const sketch of allSketches) {
            if (checkClickOnSketch(sketch)) {
                deleteSketches.push(sketch);
            }
        }

        deleteSketches.forEach((sketch) => {
            canv.canvasController.deleteProcessor(sketch.parent);
        });

        canv.redraw();
    }

    TryAction(type) {
        if (this.mode === 'eraser') {
            try {
                if (type === "mousedown") {
                    this.isEraser = true;
                    canv.eventManager.openRecord();

                    this.eraseSketchByClick();
                } else if (type === 'mousemove' && this.isEraser) {
                    this.eraseSketchByCrossing();
                } else if (type === 'mouseup') {
                    canv.eventManager.closeRecord();
                    this.isEraser = false;
                }
            } catch (err) {
                console.error(err);
                canv.captureException(err);
            }

            return;
        }

        if (type === "mousedown") {

            if (window.screen.width <= 640) {
                this.closeSubMenu();
            }

            var pt = canv.actionManager.getActionPoint();

            var newPoint = {
                "x": pt.x,
                "y": pt.y
            };

            this.ghostSketch = new sketchWidget();
            this.ghostSketch.points.push(newPoint);
            this.ghostSketch.updateDims();
            this.ghostSketch.mode = this.mode;
            this.ghostSketch.color = this.color;
            this.ghostSketch.lineWidth = this.lineWidth;

        } else if (type == "mousemove") {

            if (this.ghostSketch == null) {
                return;
            }

            var pt = canv.actionManager.getActionPoint();

            var newPoint = {
                "x": pt.x,
                "y": pt.y
            };

            this.ghostSketch.points.push(newPoint);
            this.ghostSketch.updateDims();

        } else if (type == "mouseup") {
            if (this.ghostSketch == null || this.ghostSketch == undefined) return;

            if (this.ghostSketch.points.length < 5) {
                this.ghostSketch = null;
                return;
            }


            var newGroup = new Group(true);
            this.ghostSketch.setParent(newGroup);
            canv.canvasController.addGroup(newGroup);

            canv.eventManager.openRecord();
            canv.eventManager.createBuildEvent("create", newGroup);
            canv.eventManager.closeRecord();

            this.ghostSketch = null;
        }

        canv.redraw();
    }

    chooseCursor() {
        if (this.mode === 'eraser') {
            document.body.style.cursor = `url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAACXBIWXMAAAhOAAAITgGMMQDsAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC7SURBVHgBpZILDYMwEEBvyQTgYEhAQudgDloJczAkzMkyBcwBc1AJmwO4S+6SC1ybAy55odznQdMC+CIgL2RAHrAjIjIhP5bQekSarQI9lLaIRJCN5sS1wSMQotHTc62rCeh3W35aosD5UBPIFhpDJLnMH6oKwBDd1frmFVgiIuliC74j05K0LNIx5SMCkYxHBBQ9lO+CS7BsjHsEJzVA26Lb9+Fcx/k/8i3Mv5HnmV+o8UoJ5MK50uAqZjlYShwfXgeFAAAAAElFTkSuQmCC'), auto`;
        } else {
            document.body.style.cursor = 'default';
        }
    }

    draw() {
        this.chooseCursor();

        if (this.ghostSketch == null) {
            return;
        }

        this.ghostSketch.draw();

    }

    // Далее обработчики для menu

    setColor(color) {
        this.color = color;
    }

    setWidth(width) {
        this.width = width;
    }

    name = "penTool";
    ghostSketch = null;
    mode = "pen";
    lineWidth = 6;
    color = "#000000";
    isEraser = false;
    isStartedErase = false;
}
